<template>
  <div class="htmlPreview">
    <heading type="h1">HMTL Preview</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'htmlPreview',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .htmlPreview {
        padding-top: 40px;
        text-align: center;
        width:100%;
        height:100%;
        background-color: green;
        color: white;
        position: absolute;
        top:0;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dev/html-preview.vue